<div class="global-loader-overlay" *ngIf="loaderService.loading$ | async">
  <div class="dual-ring-loader"></div>
</div>
